import { EnumDragger } from 'components/app/_mediator/app.slice';
import { useDraggerContext } from 'components/app/_mediator/app-dragger.provider';

import { usePanZoomContext } from '../_pan-zoom.provider';

export const usePanZoomDrag = () => {
  const { viewerEl, frameEl, setPanZoomRotate, setZoomRect } = usePanZoomContext();
  const { dragger } = useDraggerContext();

  const onDragStart = (e: React.PointerEvent<HTMLDivElement>) => {
    if (!viewerEl.current || !frameEl.current) return;

    const viewerRect = viewerEl.current.getBoundingClientRect();
    const frameRect = frameEl.current.getBoundingClientRect();

    if (
      e.clientX < frameRect.left ||
      e.clientX > frameRect.right ||
      e.clientY < frameRect.top ||
      e.clientY > frameRect.bottom
    )
      return;

    const offset = {
      left: e.clientX - frameRect.left,
      right: frameRect.right - e.clientX,
      top: e.clientY - frameRect.top,
      bottom: frameRect.bottom - e.clientY,
    };
    const limits = {
      left: viewerRect.left + offset.left,
      right: viewerRect.right - offset.right,
      top: viewerRect.top + offset.top,
      bottom: viewerRect.bottom - offset.bottom,
    };

    dragger(viewerEl, EnumDragger.panZoom).start(e, (e) => {
      let left = e.clientX - viewerRect.left - offset.left;
      let bottom = viewerRect.bottom - e.clientY - offset.bottom;

      if (e.clientX <= limits.left) {
        const offsetLeft = e.clientX - viewerRect.left;
        offset.left = offsetLeft <= 0 ? 0 : offsetLeft;
        offset.right = frameRect.width - offset.left;
        limits.left = viewerRect.left + offset.left;
        limits.right = viewerRect.right - offset.right;
        left = 0;
      } else if (e.clientX >= limits.right) {
        const offsetRight = viewerRect.right - e.clientX;
        offset.right = offsetRight <= 0 ? 0 : offsetRight;
        offset.left = frameRect.width - offset.right;
        limits.left = viewerRect.left + offset.left;
        limits.right = viewerRect.right - offset.right;
        left = viewerRect.width - frameRect.width;
      }

      if (e.clientY <= limits.top) {
        const offsetTop = e.clientY - viewerRect.top;
        offset.top = offsetTop <= 0 ? 0 : offsetTop;
        offset.bottom = frameRect.height - offset.top;
        limits.top = viewerRect.top + offset.top;
        limits.bottom = viewerRect.bottom - offset.bottom;
        bottom = viewerRect.height - frameRect.height;
      } else if (e.clientY >= limits.bottom) {
        const offsetBottom = viewerRect.bottom - e.clientY;
        offset.bottom = offsetBottom <= 0 ? 0 : offsetBottom;
        offset.top = frameRect.height - offset.bottom;
        limits.top = viewerRect.top + offset.top;
        limits.bottom = viewerRect.bottom - offset.bottom;
        bottom = 0;
      }

      setPanZoomRotate({ left, bottom });
    });
  };

  const onDragEnd = (e: React.PointerEvent<HTMLDivElement>) => {
    dragger(viewerEl, EnumDragger.panZoom).end(e);
    setZoomRect();
  };

  return { onDragStart, onDragEnd };
};
